export const ALL_SAVED_SEARCH_SET = 'ALL_SAVED_SEARCH_SET'
export const ALL_SAVED_SEARCH_REQ = 'ALL_SAVED_SEARCH_REQ'
export const ALL_SAVED_SEARCH_SUCCESS = 'ALL_SAVED_SEARCH_SUCCESS'
export const ALL_SAVED_SEARCH_ERROR = 'ALL_SAVED_SEARCH_ERROR'
export const ALL_SAVED_SEARCH_RESET_STATUS = 'ALL_SAVED_SEARCH_RESET_STATUS'

export const GET_SAVED_SEARCH_REQ = 'GET_SAVED_SEARCH_REQ'
export const GET_SAVED_SEARCH_SUCCESS = 'GET_SAVED_SEARCH_SUCCESS'
export const GET_SAVED_SEARCH_ERROR = 'GET_SAVED_SEARCH_ERROR'
export const GET_SAVED_SEARCH_RESET_STATUS = 'GET_SAVED_SEARCH_RESET_STATUS'

export const SAVED_SEARCH_POST = 'SAVED_SEARCH_POST'
export const SAVED_SEARCH_POST_SUCCESS = 'SAVED_SEARCH_POST_SUCCESS'
export const SAVED_SEARCH_POST_ERROR = 'SAVED_SEARCH_POST_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/threat_hunting/saved-search.type.js